import { useRef } from 'react';

const useEventEndHandler = (callback, timeout = 100) => {
  const timeoutID = useRef(null);
  return () => {
    window.clearTimeout(timeoutID.current);
    timeoutID.current = window.setTimeout(callback, timeout);
  };
};

export default useEventEndHandler;
